<div id="feedback-screend-reader" class="only-screen-reader" [ngClass]="{'hidden': hideStatusResult}" aria-live="assertive" aria-atomic="true">
  <span>{{statusResult}}</span>
</div>
<form (submit)="false">
  <div class="input-text line2" [ngClass]="{'line2-error': errorMsgTextSearch}">
    <span *ngIf="errorMsgTextSearch" class="error-text" aria-hidden="true">{{textError}}</span>
      <input
      #inputSearch
      id="search-list"
      type="search"
      name="search"
      role="searchbox"
      value="{{textSearch}}"
      [attr.aria-label]="ariaLabelInput"
      [attr.placeholder]="textSearch === '' || textSearch === undefined ? placeholder : ''" 
      [attr.maxLength]="maxLength"
      autocomplete="off"
      (paste)="false"
      (drop)="false"
      (keyup)="submitInput($event); checkTextSearch($event)"
      (input)="textSearch = $event.target.value; sendTextSearch.emit($event.target.value);">
  
    <span
    id="btn-clean-search"
    [ngClass]="{'hidden': !textSearch || textSearch?.length === 0}"
    role="button"
    aria-label="apagar busca"
    tabindex="0"
    (click)="resetSearch($event)">
      <img aria-hidden="true" src="/assets/images/svg/clean-search.svg" alt="icon">
    </span>
  </div>
</form>
